import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _adminRemoveMenuItemsResponse = {};
var _collection = {
    sortOrder: 'google.protobuf.DoubleValue',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    coverImage: '_image',
};
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _createCollectionRequest = { collection: '_collection' };
var _createCollectionResponse = { collection: '_collection' };
var _deleteCollectionRequest = {};
var _deleteCollectionResponse = {};
var _empty = {};
var _getCollectionRequest = {};
var _getCollectionResponse = { collection: '_collection' };
var _image = {
    imageInfo: '_commonImage',
    focalPoint: '_point',
    unsharpMasking: '_unsharpMasking',
};
var _listCollectionsRequest = {};
var _listCollectionsResponse = { collections: '_collection' };
var _point = { x: 'DOUBLE', y: 'DOUBLE' };
var _queryCollectionsRequest = {};
var _queryCollectionsResponse = { collections: '_collection' };
var _unsharpMasking = {
    amount: 'google.protobuf.FloatValue',
    radius: 'google.protobuf.FloatValue',
    threshold: 'google.protobuf.FloatValue',
};
var _updateCollectionRequest = {
    mask: 'google.protobuf.FieldMask',
    collection: '_collection',
};
var _updateCollectionResponse = { collection: '_collection' };
function resolveComWixpressPortfolioCollectionsCollectionsServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/collections-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/collections',
                destPath: '/api/v1/portfolio/collections',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/collections-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressPortfolioPortfolioappPortfolioMenuServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/settings',
                destPath: '/api/v1/portfolio/settings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function adminRemoveMenuItems(payload) {
    var _a = serializer(_empty, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_adminRemoveMenuItemsResponse, {}).fromJSON;
    function __adminRemoveMenuItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.portfolioapp.PortfolioMenuService.AdminRemoveMenuItems',
            url: resolveComWixpressPortfolioPortfolioappPortfolioMenuServiceUrl({
                protoPath: '/api/admin/clear-menu-item-entities',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __adminRemoveMenuItems.fromReq = fromReq;
    __adminRemoveMenuItems.__isAmbassador = true;
    return __adminRemoveMenuItems;
}
/** Creates a collection. */
export function createCollection(payload) {
    var _a = serializer(_createCollectionRequest, { _collection: _collection, _commonImage: _commonImage, _image: _image, _point: _point, _unsharpMasking: _unsharpMasking }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCollectionResponse, {
        _collection: _collection,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
    }).fromJSON;
    function __createCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.CreateCollection',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCollection.fromReq = fromReq;
    __createCollection.__isAmbassador = true;
    return __createCollection;
}
/** Retrieves a collection. */
export function getCollection(payload) {
    var _a = serializer(_getCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCollectionResponse, {
        _collection: _collection,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
    }).fromJSON;
    function __getCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.GetCollection',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections/{collectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCollection.fromReq = fromReq;
    __getCollection.__isAmbassador = true;
    return __getCollection;
}
/** Retrieves a list all collections in a portfolio. */
export function listCollections(payload) {
    var _a = serializer(_listCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCollectionsResponse, {
        _collection: _collection,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
    }).fromJSON;
    function __listCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.ListCollections',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCollections.fromReq = fromReq;
    __listCollections.__isAmbassador = true;
    return __listCollections;
}
/** Updates a collection. */
export function updateCollection(payload) {
    var _a = serializer(_updateCollectionRequest, { _collection: _collection, _commonImage: _commonImage, _image: _image, _point: _point, _unsharpMasking: _unsharpMasking }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCollectionResponse, {
        _collection: _collection,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
    }).fromJSON;
    function __updateCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.UpdateCollection',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections/{collection.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCollection.fromReq = fromReq;
    __updateCollection.__isAmbassador = true;
    return __updateCollection;
}
/** Deletes a collection. */
export function deleteCollection(payload) {
    var _a = serializer(_deleteCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCollectionResponse, {}).fromJSON;
    function __deleteCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'DELETE',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.DeleteCollection',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections/{collectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCollection.fromReq = fromReq;
    __deleteCollection.__isAmbassador = true;
    return __deleteCollection;
}
/**
 * Retrieves a list of collections given the provided paging, filtering, and sorting. Up to 100 collections can be returned per request.
 *
 * The default `sort` is `id` in `ASC`.
 *
 * For a detailed list of supported operations, see [Collections: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/portfolio/collections/sort-and-filter).
 * To learn how to query collections, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryCollections(payload) {
    var _a = serializer(_queryCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCollectionsResponse, {
        _collection: _collection,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
    }).fromJSON;
    function __queryCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.collections.v1.collection',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.collections.CollectionsService.QueryCollections',
            url: resolveComWixpressPortfolioCollectionsCollectionsServiceUrl({
                protoPath: '/api/v1/portfolio/collections/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCollections.fromReq = fromReq;
    __queryCollections.__isAmbassador = true;
    return __queryCollections;
}
//# sourceMappingURL=http.impl.js.map